// extracted by mini-css-extract-plugin
export default {"logo":"Login_logo__sZA06","logodiv":"Login_logodiv__zxHlU","box":"Login_box__4R8J+","label":"Login_label__aj9QJ","password":"Login_password__msNdw","button":"Login_button__gzyPs"};